import React from 'react'
import Footer from './Footer';
import FooterApp from './FooterApp';

export default function index() {
  return (
    window.innerWidth > 500 ? <Footer /> : <FooterApp />
  )
}
